"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconRoles = function IconRoles(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconRoles', className),
    style: style,
    viewBox: "0 0 24 22"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.3"
  }, _react.default.createElement("g", {
    fillRule: "nonzero"
  }, _react.default.createElement("path", {
    d: "M21.56 8.055C20.301 3.969 16.497 1 12 1 7.528 1 3.741 3.936 2.462 7.985"
  }), _react.default.createElement("path", {
    d: "M19.53 7.619l2.537 1.656.88-2.9"
  })), _react.default.createElement("g", {
    transform: "translate(8 5)"
  }, _react.default.createElement("path", {
    d: "M2.333 6.333h3.5a2.333 2.333 0 0 1 2.334 2.334V10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8.667a2.333 2.333 0 0 1 2.333-2.334z"
  }), _react.default.createElement("ellipse", {
    cx: "4.051",
    cy: "2.5",
    rx: "2.051",
    ry: "2"
  })), _react.default.createElement("g", {
    fillRule: "nonzero"
  }, _react.default.createElement("path", {
    d: "M21.56 14c-1.258 4.085-5.062 7.055-9.56 7.055-4.472 0-8.259-2.936-9.538-6.986"
  }), _react.default.createElement("path", {
    d: "M4.97 15.381l-2.537-1.656-.88 2.9"
  }))));
};

var _default = IconRoles;
exports.default = _default;